<template>
    <div class="player-info-view">
        <PopupCover @close="close()">
            <PopupBody @close="close()">
                <template #header>
                    Player Information
                </template>
                <template #body>
                    <div class="properties">
                        <p class='text-left' v-for="(value, key) in playerData" :key="key">
                            <strong>{{ key }}:</strong> 
                            <span v-if="countyFields.includes(key) && value" class="flag">
                                <span :class="`fi fi-${value.toLowerCase()}`"></span>
                            </span>

                            {{ value }}
                            
                        </p>
                    </div>
                </template>

            </PopupBody>
        </PopupCover>
    </div>
</template>

<script setup>
    import { ref, computed, defineEmit, onMounted } from 'vue';
    import API from '../api';
    import store from '../store';
    import PopupCover from './PopupCover.vue';
    import PopupBody from './PopupBody.vue';


    const emit = defineEmits(['close']);
    const playerData = ref(null);
    const props = defineProps({
        playerId: {
            type: String,
            required: true
        }
    });
    const countyFields = [
        'Nationality',
        'PassportCountry',
        'IdentificationCountry',
        'Country',
        'ResidenceCountry'
    ];

    function close() {
        emit('close');
    }

    onMounted( async () => {
        const playerInfo = await API.getPlayerInfo(props.playerId);
        playerData.value = playerInfo.data;
    })


</script>


<style scoped lang="scss">

    .properties {
        p {
            margin: 0.5em 0;
        }
    }
    .flag {
        margin-left: 0.5em;
    }
</style>